export default "__VITE_ASSET__CDNwpDV4__"